module.exports = __webpack_public_path__ + "static/media/ico-whatsapp.953a8c3e.png";